import { Map } from "immutable";
import { singleton } from "logic/singleton";
class WidgetPosition {
  constructor(col, row, height, width) {
    this._value = { col, row, height, width };
  }
  static fromJSON(value) {
    const { col, row, height, width } = value;
    const newCol = col === "Infinity" ? Infinity : col;
    const newRow = row === "Infinity" ? Infinity : row;
    const newHeight = height === "Infinity" ? Infinity : height;
    const newWidth = width === "Infinity" ? Infinity : width;
    return new WidgetPosition(newCol, newRow, newHeight, newWidth);
  }
  get col() {
    return this._value.col;
  }
  get row() {
    return this._value.row;
  }
  get height() {
    return this._value.height;
  }
  get width() {
    return this._value.width;
  }
  toJSON() {
    const { col, row, height, width } = this._value;
    const newCol = col === Infinity ? "Infinity" : col;
    const newRow = row === Infinity ? "Infinity" : row;
    const newHeight = height === Infinity ? "Infinity" : height;
    const newWidth = width === Infinity ? "Infinity" : width;
    return {
      col: newCol,
      row: newRow,
      height: newHeight,
      width: newWidth
    };
  }
  toBuilder() {
    return new Builder(Map(this._value));
  }
  static builder() {
    return new Builder();
  }
  equals(other) {
    if (other instanceof WidgetPosition) {
      return this.col === other.col && this.row === other.row && this.height === other.height && this.width === other.width;
    }
    return false;
  }
}
class Builder {
  constructor(value = Map()) {
    this.value = value;
  }
  col(value) {
    this.value = this.value.set("col", value);
    return this;
  }
  row(value) {
    this.value = this.value.set("row", value);
    return this;
  }
  height(value) {
    this.value = this.value.set("height", value);
    return this;
  }
  width(value) {
    this.value = this.value.set("width", value);
    return this;
  }
  build() {
    const { col, row, height, width } = this.value.toObject();
    return new WidgetPosition(col, row, height, width);
  }
}
const SingletonWidgetPosition = singleton("views.logic.widgets.WidgetPosition", () => WidgetPosition);
export default SingletonWidgetPosition;
